import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

// Table Skeleton - for loading building tables
export const TableSkeleton = ({ rows = 5, columns = 4 }) => {
  return (
    <div style={{ width: '100%' }}>
      {/* Table Header */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: '1rem',
        padding: '0.75rem',
        borderBottom: '2px solid #e2e8f0',
        backgroundColor: '#f8fafc'
      }}>
        {[...Array(columns)].map((_, i) => (
          <Skeleton key={i} height={20} width="80%" />
        ))}
      </div>

      {/* Table Rows */}
      {[...Array(rows)].map((_, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: '1rem',
            padding: '1rem 0.75rem',
            borderBottom: '1px solid #f1f5f9'
          }}
        >
          {[...Array(columns)].map((_, colIndex) => (
            <Skeleton key={colIndex} height={colIndex === 0 ? 20 : 30} width={colIndex === 0 ? '90%' : '60%'} />
          ))}
        </div>
      ))}
    </div>
  );
};

// Card Skeleton - for loading dashboard cards
export const CardSkeleton = ({ count = 3 }) => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '1.5rem',
      marginBottom: '2rem'
    }}>
      {[...Array(count)].map((_, i) => (
        <div
          key={i}
          style={{
            backgroundColor: 'white',
            border: '1px solid #e2e8f0',
            borderRadius: '0.5rem',
            padding: '1.5rem'
          }}
        >
          <Skeleton height={20} width="60%" style={{ marginBottom: '0.5rem' }} />
          <Skeleton height={36} width="40%" style={{ marginBottom: '0.5rem' }} />
          <Skeleton height={16} width="80%" />
        </div>
      ))}
    </div>
  );
};

// Stats Grid Skeleton - for loading statistics
export const StatsGridSkeleton = () => {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '1.5rem',
      marginBottom: '2rem'
    }}>
      {[...Array(4)].map((_, i) => (
        <div
          key={i}
          style={{
            backgroundColor: 'white',
            border: '1px solid #e2e8f0',
            borderRadius: '0.5rem',
            padding: '1.5rem'
          }}
        >
          <Skeleton height={14} width="70%" style={{ marginBottom: '0.5rem' }} />
          <Skeleton height={32} width="50%" />
        </div>
      ))}
    </div>
  );
};

// Building List Skeleton - for property manager dashboard
export const BuildingListSkeleton = ({ count = 3 }) => {
  return (
    <div>
      {[...Array(count)].map((_, i) => (
        <div
          key={i}
          style={{
            backgroundColor: 'white',
            border: '1px solid #e2e8f0',
            borderRadius: '0.75rem',
            padding: '1.5rem',
            marginBottom: '1rem'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
            <div style={{ flex: 1 }}>
              <Skeleton height={24} width="70%" style={{ marginBottom: '0.5rem' }} />
              <Skeleton height={16} width="50%" style={{ marginBottom: '0.5rem' }} />
              <Skeleton height={16} width="40%" />
            </div>
            <div>
              <Skeleton circle width={60} height={60} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            <div>
              <Skeleton height={12} width={80} style={{ marginBottom: '0.25rem' }} />
              <Skeleton height={20} width={40} />
            </div>
            <div>
              <Skeleton height={12} width={80} style={{ marginBottom: '0.25rem' }} />
              <Skeleton height={20} width={40} />
            </div>
            <div>
              <Skeleton height={12} width={80} style={{ marginBottom: '0.25rem' }} />
              <Skeleton height={20} width={40} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Chart Skeleton - for loading charts
export const ChartSkeleton = ({ height = 300 }) => {
  return (
    <div style={{
      backgroundColor: 'white',
      border: '1px solid #e2e8f0',
      borderRadius: '0.5rem',
      padding: '1.5rem'
    }}>
      <Skeleton height={24} width="40%" style={{ marginBottom: '1rem' }} />
      <Skeleton height={height} />
    </div>
  );
};

export default {
  TableSkeleton,
  CardSkeleton,
  StatsGridSkeleton,
  BuildingListSkeleton,
  ChartSkeleton
};
